export const arraysAreEqual = (arrOne, arrTwo) => {
    if (arrOne.length !== arrTwo.length)
        return false;
    for (let index = 0; index < arrOne.length; index++) {
        if (arrOne[index] !== arrTwo[index])
            return false;
    }
    return true;
};
//# sourceMappingURL=arraysAreEqual.js.map